import * as React from "react"
import IconSkeleton from "./IconSkeleton"
import { IconProps } from "./types"

export default function FastSpeedIcon(props: IconProps) {
  return (
    <IconSkeleton
      {...props}
      iconName="FastSpeedIcon"
      applyColorToStroke={false}
    >
      <path
        d="M12.6979 15.1239C12.4765 15.2156 12.2392 15.2627 11.9996 15.2625C11.76 15.2627 11.5227 15.2156 11.3013 15.1239C11.0799 15.0323 10.8788 14.8979 10.7094 14.7285C10.5399 14.5591 10.4056 14.3579 10.3139 14.1365C10.2223 13.9151 10.1752 13.6778 10.1753 13.4382L11.9996 4.31677L13.8239 13.4382C13.824 13.6778 13.777 13.9151 13.6853 14.1365C13.5937 14.3579 13.4593 14.5591 13.2899 14.7285C13.1205 14.8979 12.9193 15.0323 12.6979 15.1239ZM19.447 14.4229C19.447 11.3278 17.5589 8.67376 14.8716 7.54968L14.1323 5.14703C18.361 6.11519 21.5156 9.90065 21.5156 14.4229C21.5156 15.8786 21.1873 17.2633 20.5988 18.5022C20.2562 19.2235 19.5289 19.6832 18.7303 19.6832H5.26943C4.47084 19.6832 3.74357 19.2235 3.40091 18.5022C2.81241 17.2633 2.48413 15.8786 2.48413 14.4229C2.48413 9.90066 5.63871 6.11521 9.86738 5.14704L9.1281 7.54969C6.44087 8.67379 4.55277 11.3279 4.55277 14.4229C4.55277 15.5651 4.8099 16.6472 5.26943 17.6145H18.7303C19.1899 16.6472 19.447 15.5651 19.447 14.4229Z"
        fill="currentColor"
      />
    </IconSkeleton>
  )
}
